<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp;文件上传
      </h4></el-col
    >
    <el-col class="col">
      <ul class="ul">
        <li>
          请根据要求上传一个.docx稿件，一个.pdf稿件，其他补充文件请打包成压缩文件，以附件形式上传。
        </li>
        <br />
        <li class="attention">
          注意：非最终版本稿件，上传的文件中请勿出现作者信息。定稿后再完善稿件作者信息。
        </li>
        <br />
      </ul>
    </el-col>
    <el-upload
      class="upload-demo"
      drag
      action="https://www.exp-linguistics.net/manuscript/manuscripts/upload"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :before-upload="beforeFileUpload"
      :name="'file'"
      :on-exceed="handleExceed"
      :show-file-list="true"
      :file-list="fileList"
      :on-remove="handleRemove"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    </el-upload>

    <el-row></el-row>
    <!-- <el-col>{{ fileInfo.content.mainDocx }}</el-col>
    <el-col>{{ fileInfo.content.mainPdf }}</el-col>
    <el-col>{{ fileInfo.content.allFile }}</el-col> -->
    <br />
    <el-col class="h4">
      <el-button class="save" @click.native="ts()">保存</el-button>
    </el-col>
  </div>
</template>

<script>
import { tsFileInfo, getTsFileInfo, upload } from '@/api/data'
export default {
  name: 'FileInfoComponent',
  data () {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      userInfo: null,
      fileList: [],
      fileInfo: { content: '', address: '' }
    }
  },
  methods: {
    beforeFileUpload (file) {
      let fileType = '.' + file.name.split('.')[1]

      for (let index in this.fileList) {
        if (
          this.fileList[index].response.fileType == fileType &&
          (fileType == '.docx' || fileType == '.pdf')
        ) {
          this.$message({
            message: 'docx文件和pdf文件数量过多！',
            center: true
          })
          return false
        }
      }
    },
    uploadSuccess (response, file, fileList) {
      this.fileInfo.content = response.result.fileType
      this.fileInfo.address = response.result.filename
      this.fileList = fileList
    },
    uploadFail (err, file, fileList) {
      this.$message.error('上传失败-请联系管理员！')
    },
    handleRemove (file, fileList) {
      this.fileList = fileList
    },
    handlePreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleExceed (files, fileList) {
      this.$message.error('文件数量不能超过1')
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    uploadFile () {
      upload(this.fileInfo.address).then((res) => {})
    },
    ts () {
      const next = this
      let docCount = 0
      let pdfCount = 0
      let content = {
        mainDocx: '',
        mainPdf: '',
        allFile: []
      }

      for (let index in this.fileList) {
        if (this.fileList[index].response.result.fileType == '.docx') {
          docCount += 1
          content.mainDocx = this.fileList[index].response.result.filename
        } else if (this.fileList[index].response.result.fileType == '.pdf') {
          pdfCount += 1
          content.mainPdf = this.fileList[index].response.result.filename
        } else {
          content.allFile.push(this.fileList[index].response.result.filename)
        }
      }
      if (docCount == 0 || pdfCount == 0) {
        this.$message({
          message: '请至少上传一个pdf与一个docx文件！',
          center: true
        })
        return false
      }
      this.fileInfo.content = content
      tsFileInfo({
        key: this.userInfo.email,
        fileInfo: this.fileInfo
      }).then((res) => {
        if (res.data.result == true) {
          this.$message({
            message: '文件信息已保存',
            type: 'success'
          })
        } else {
          this.$message({
            message: '文件信息保存有误',
            type: 'error'
          })
        }
      })
    },
    getTs () {
      getTsFileInfo({
        key: this.userInfo.email
      }).then((res) => {
        if (res.data.result.fileInfo != null) {
          this.fileInfo = res.data.result.fileInfo
        }
      })
    }
  },
  mounted () {
    let userInfo = this.$cookie.getCookie('userInfo')
    // if (userInfo == null || userInfo.type != "投稿人") {
    //   this.$message({
    //     message: "请先登录！",
    //     type: "error",
    //   });
    //   this.$router.push("index");
    // }
    this.userInfo = userInfo
    this.getTs()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}
.col {
  text-align: left;
}
.ul {
  list-style: none;
}
.attention {
  color: red;
}
.upload-demo .el-upload-list {
  display: none;
}
.ts {
  width: 150px;
  border-color: #12696e;
  border-width: 1px;
  border-radius: 0px;
}
.save {
  background-color: #054a48;
  color: white;
  width: 150px;
  border: none;
  border-radius: 0px;
}
button:hover {
  background-color: #0a696f;
  color: white;
  border-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/fileInfoComponent.vue